import { render, staticRenderFns } from "./SelectOTPLogin.vue?vue&type=template&id=4b7af39b&lang=html"
import script from "./SelectOTPLogin.vue?vue&type=script&lang=js"
export * from "./SelectOTPLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports